import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeInsightUserChallenge: any[] = [
  {
    route: 'Challenges',
    text: 'Challenges',
    href: '/frontoffice/insight/challenges',
    t: 'routes.frontoffice.insight.challenges',
    icon: EmojiEventsIcon,
    // DESACTIVE (dev ET prod, decision 2026-07-27) : l'entree disparait de tous les menus
    // — sidebar, menu mobile, page de demarrage, favoris. La page reste accessible par URL.
    menuHeader: false,
    position: 110,
  },
  {
    route: 'ChallengesStart',
    text: 'Démarrer un questionnaire',
    t: 'routes.frontoffice.insight.challengesStart',
    href: '/frontoffice/insight/challenges/[repartitionProgramUserChallengeId]/start',
  },
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDINSIGHT],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_PHARMACIEN, CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_USER_TEAM],
}))
